export class IDocument {
    documentId: string;
    documentName: string;
    documentdate: string;
    subCategoryId: number;
    subCategoryName: string;
    //categoryId: number;
    docCategoryId: number;
    documentCategory: string;
    patientId: number;
    patFullName: string;
    patDOB: Date;
    patGender: string;
    patAge: number;
    extension: string;
    encounterId: string;
    facilityId: number;
    createdBy: string;
    locationId: number;
    fluoroscopeId: number;
    count: number;
    reportDocumentId: number;
    CategoryRole?: string;
    CategoryPermissions?: string;
    sasUri?:string;
    //urlPath:string;
    // smallSizeImage: any;
    // actualSizeImage: any;
    // scanType: string;    
    // docDescription: string;
    // modifiedBy: string;
    // dBOperation: string;
    // isActive: boolean;
    // docParent: number;
    // createdOn: number;
    // childDocCategories: IDocument[];
    // value: string;
    // operation: string;
    // createOn: string;
    // multipleScans: IImageDocument[];
    // count: number;
    // dateofService: Date;
    // applicationId: number;
    // orderId: number;
    // serialNo: number;
    // providerName: string;
    // documentImageId: number;
    // docComments: string;
    // providerFullName: string;

}
export interface Idocument_DIrectmsg extends IDocument {
    createdDate?: string;
    Notes?: string;
}
export interface IDocument_locname {
    documentId: string;
    documentName: string;
    documentdate: string;
    subCategoryId: number;
    subCategoryName: string;
    //categoryId: number;
    docCategoryId: number;
    documentCategory: string;
    patientId: number;
    patFullName: string;
    patDOB: Date;
    patGender: string;
    patAge: number;
    extension: string;
    encounterId: string;
    facilityId: number;
    createdBy: string;
    locationId: number;
    fluoroscopeId: number;
    count: number;
    reportDocumentId: number;
    locationName: string;
    LocationName?: string;
    DocumentType?: string;
    DocNotes?: string;
    Docpath?: string;
    CategoryPermissions?: string;
    refDocID?: string;
    refLocname?: string;
    docFileURL: string;
    visitDate: string;
    isSelected?: boolean;
}

export interface ISubCategorys {
    subCategoryId: number;
    CategoryId: number
    subCategoryName: string;
    isActive: boolean;
    createdby: string;
}

export interface ISignatures {
    signatureId: number;
    Signature: String;
}
export interface ISignaturesNew {
    SignatureID: number;
    SignatureBy: String;
    IsSignaturechecked: boolean;
}

export interface IPatientDetails_DocLibrary {
    PatId: number;
    LastName: string;
    MiddleName: string;
    FirstName: string;
    patientName: string;
    Gender: string;
    DOB: Date;
    Salutation: string;
    PatientAddress: string;
    HomePhone: string;
    WorkPhone: string;
    CellPhone: string;
    EmailId: string;
    Age: Number;
    defaultProviderAddress: string;
    defaultProviderName: string;
    Insurance1st: string;
    Insurance2nd: string;
    Insurance3rd: string;
    PharmaName: string;
    PharmaAddress: string;
    PharmaPhoneFAX: string;
}


export interface ILocationDetails_ID_DocLibrary {
    LocationId: number;
    Clinictimmings: string;
    ContactNo: string;
    LocNameAddress: string;
}
// export interface IImageDocument {
//     actualSizeImage: any;
//     extension: string;
//     createdBy: string;
//     documentImageId: any;
//     documentName: string;
//     documentId: number;
//     documentCategory: string;
//     documentdate: string;
//     providerName: string;
//     docDescription: string;
//     createdOn: string;
//     categoryId: number;
//     patientId: number;
//     patientName: string;
//     docComments: string;
// }
export interface DocumentCategoryUserRolePermissions {

    id: number;
    roleid: string;
    userid: string;
    DocumentTypeID: number;
    permissions: string;
    LoginUser: string;
    DocumentType: string;
    isActive: boolean;
    serverresponse: string;
    locationId: string;
    MainCategory?: string;
}
export interface AciveUsersPermissions {
    id: number;
    roleid: string;
    UserId: string;
    loginUser: string;
    isActive: boolean;
    visitnote: string;
    serverresponse: string;
    locationId: string;
}
export class PatientTeleDoc {
    chatDocId: number;
    patientId: number;
    locationId: number;
    documentText: string;
    encounterId: string;
    fileExtension: string;
    documentId: number;
}